import { render, staticRenderFns } from "./expAuthority.vue?vue&type=template&id=85784480&scoped=true&"
import script from "./expAuthority.vue?vue&type=script&lang=js&"
export * from "./expAuthority.vue?vue&type=script&lang=js&"
import style0 from "./expAuthority.vue?vue&type=style&index=0&id=85784480&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85784480",
  null
  
)

export default component.exports